<template>
  <div>
    <app-title>{{$route.name}}</app-title>
    <partner-list></partner-list>
  </div>
</template>

<script>
export default {
  name: "ListPartners",
  components: {
    PartnerList: () => import("@/components/partner/partner-list")
  }
};
</script>

<style scoped>
</style>